/* eslint-disable react/button-has-type, jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary, jsx-a11y/no-autofocus, react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { MF } from '../constants';

/**
 * Shared Form Field component
 */
export function F({
  label,
  name,
  value,
  onChange,
  type = 'text',
  options,
  disabled,
  radioOptions,
  check,
  style,
  maxLength,
  min,
  max,
  step,
  required,
  pattern,
  numericOnly = false,
  hideInvalidFormatMessage = false,
  children,
}) {
  const req = required !== undefined ? required : MF.has(name);
  const isValid = !pattern || !value || new RegExp(pattern).test(value);
  const [dateDraft, setDateDraft] = useState('');
  const datePickerRef = useRef(null);

  const toDisplayDate = dateValue => {
    if (dateValue && dateValue.includes('-')) {
      return dateValue.split('-').reverse().join('/');
    }
    return dateValue || '';
  };

  const parseDisplayDateToIso = dateValue => {
    const trimmed = String(dateValue || '').trim();
    if (!trimmed) return '';
    const match = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) return null;

    const [, dd, mm, yyyy] = match;
    const parsed = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
    if (
      Number.isNaN(parsed.getTime()) ||
      parsed.getUTCFullYear() !== Number(yyyy) ||
      parsed.getUTCMonth() + 1 !== Number(mm) ||
      parsed.getUTCDate() !== Number(dd)
    ) {
      return null;
    }

    return `${yyyy}-${mm}-${dd}`;
  };

  const sanitizeDateDraft = draft =>
    String(draft || '')
      .replace(/[^\d/]/g, '')
      .slice(0, 10);

  useEffect(() => {
    if (type !== 'date') return;
    setDateDraft(toDisplayDate(value));
  }, [type, value]);

  if (check) {
    return (
      <label className={`ck ${disabled ? 'is-disabled' : ''}`} style={style}>
        <input
          type="checkbox"
          id={`f-${name}`}
          checked={!!value}
          onChange={e => {
            if (disabled) return;
            onChange(name, e.target.checked);
          }}
          aria-disabled={disabled}
        />
        {check}
      </label>
    );
  }
  if (radioOptions) {
    return (
      <div className="fg" style={style}>
        <label className="my-1 form-label">
          {label}
          {req && <span className="text-danger">*</span>}
        </label>
        <div className="rr">
          {radioOptions.map(o => (
            <label key={o} className={`ro ${disabled ? 'is-disabled' : ''}`}>
              <input
                type="radio"
                id={`f-${name}-${o}`}
                name={name}
                value={o}
                checked={value === o}
                onChange={e => onChange(name, e.target.value)}
                disabled={disabled}
              />
              {o}
            </label>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="fg" style={style}>
      <label className="my-1 form-label">
        {label}
        {req && <span className="text-danger">*</span>}
        {!isValid && !hideInvalidFormatMessage && (
          <span className="text-danger ms-2" style={{ fontSize: '10px' }}>
            Invalid format
          </span>
        )}
      </label>
      {children ||
        (options ? (
          <div className="sw">
            <select
              className="form-select external-filter-input form-select"
              id={`f-${name}`}
              value={value ?? ''}
              onChange={e => onChange(name, e.target.value)}
              disabled={disabled}
            >
              <option value="">Select {label}</option>
              {options.map(o => {
                const isObj = typeof o === 'object' && o !== null;
                const v = isObj ? o.value : o;
                const l = isObj ? o.label : o;
                return (
                  <option key={v} value={v}>
                    {l}
                  </option>
                );
              })}
            </select>
          </div>
        ) : type === 'date' ? (
          <div className="dw">
            <div
              className="d-ico"
              onClick={() => {
                if (disabled) return;
                if (datePickerRef.current?.showPicker) {
                  datePickerRef.current.showPicker();
                } else {
                  datePickerRef.current?.focus();
                }
              }}
              role="button"
              tabIndex={-1}
              onKeyDown={e => {
                if (disabled) return;
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  if (datePickerRef.current?.showPicker) {
                    datePickerRef.current.showPicker();
                  } else {
                    datePickerRef.current?.focus();
                  }
                }
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect
                  x="3"
                  y="4"
                  width="18"
                  height="18"
                  rx="2"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="M16 2v4M8 2v4M3 10h18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <input
              id={`f-${name}`}
              type="text"
              placeholder="DD/MM/YYYY"
              onChange={e => setDateDraft(sanitizeDateDraft(e.target.value))}
              onBlur={() => {
                const parsedDate = parseDisplayDateToIso(dateDraft);
                if (parsedDate === null) {
                  setDateDraft(toDisplayDate(value));
                  return;
                }
                onChange(name, parsedDate);
                setDateDraft(toDisplayDate(parsedDate));
              }}
              onClick={() => {
                if (disabled) return;
                if (datePickerRef.current?.showPicker) {
                  datePickerRef.current.showPicker();
                }
              }}
              className="form-control external-filter-input form-control"
              value={dateDraft}
              disabled={disabled}
            />
            <input
              ref={datePickerRef}
              type="date"
              tabIndex={-1}
              aria-hidden="true"
              style={{
                position: 'absolute',
                opacity: 0,
                width: 0,
                height: 0,
                pointerEvents: 'none',
              }}
              value={value ?? ''}
              onChange={e => {
                onChange(name, e.target.value);
                setDateDraft(toDisplayDate(e.target.value));
              }}
              disabled={disabled}
            />
          </div>
        ) : (
          <input
            id={`f-${name}`}
            type={type}
            className={`form-control external-filter-input ${
              !isValid ? 'is-invalid border-danger' : ''
            }`}
            value={value ?? ''}
            onChange={e => {
              const nextValue = numericOnly
                ? String(e.target.value || '').replace(/\D/g, '')
                : e.target.value;
              onChange(name, nextValue);
            }}
            disabled={disabled}
            maxLength={maxLength}
            inputMode={numericOnly ? 'numeric' : undefined}
            {...(type === 'number'
              ? {
                  ...(min !== undefined && { min }),
                  ...(max !== undefined && { max }),
                  ...(step !== undefined && { step }),
                }
              : {})}
          />
        ))}
    </div>
  );
}

/** Grouped section with teal header bar and icon */
export function Section({ title, icon, children, cols = 3 }) {
  return (
    <div className="sec">
      <div className="sec-h">
        <div className="sec-h-icon">{icon}</div>
        <span>{title}</span>
      </div>
      <div className={`sec-body sec-cols-${cols}`}>{children}</div>
    </div>
  );
}

/** Close button SVG (shared across modals) */
export function CloseIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M18 6L6 18M6 6l12 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Edit action button SVG */
export function EditIcon({ size = 14, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}

/** Save action button SVG */
export function SaveIcon({ size = 14, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 21v-8H7v8M7 3v5h8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Delete action button SVG */
export function DeleteIcon({ size = 14, color = '#ef4444' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M3 6h18M8 6V4h8v2m1 0v14a1 1 0 01-1 1H8a1 1 0 01-1-1V6"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}

/** Table action buttons (edit + delete) */
export function TableActions({ onEdit, onDelete, readOnly }) {
  const muted = '#94a3b8';
  return (
    <div className="dep-acts">
      <button
        type="button"
        className="att-ab"
        onClick={onEdit}
        disabled={readOnly}
        title={readOnly ? 'View only' : 'Edit'}
      >
        <EditIcon color={readOnly ? muted : '#0891b2'} />
      </button>
      <button
        type="button"
        className="att-ab del"
        onClick={onDelete}
        disabled={readOnly}
        title={readOnly ? 'View only' : 'Delete'}
      >
        <DeleteIcon color={readOnly ? muted : '#ef4444'} />
      </button>
    </div>
  );
}

/** Delete confirmation dialog */
export function ConfirmModal({ msg, onYes, onNo, loading }) {
  return (
    <div className="ov" onClick={loading ? undefined : onNo}>
      <div className="cfm" onClick={e => e.stopPropagation()}>
        <div className="cfm-ico">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 9v4m0 4h.01"
              stroke="#ef4444"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2" />
          </svg>
        </div>
        <h3 className="cfm-t">Confirm Delete</h3>
        <p className="cfm-msg">{msg}</p>
        <div className="cfm-btns">
          <button className="btn em-btn" onClick={onNo} disabled={loading}>
            Cancel
          </button>
          <button
            className="btn em-btn em-btn-danger"
            onClick={onYes}
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Yes, Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}

/** Auto-dismiss toast notification */
export function Toast({ message, type, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 3200);
    return () => clearTimeout(t);
  }, [onClose]);
  const icons = {
    success: 'M20 6L9 17l-5-5',
    info: 'M12 16v-4m0-4h.01',
  };
  return (
    <div className={`emp-toast et-${type} ${type}`}>
      {type === 'error' ? (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
          <circle
            cx="12"
            cy="12"
            r="10"
            fill="#fff"
            stroke="#dc3545"
            strokeWidth="2"
          />
          <path
            d="M12 8v5M12 16h.01"
            stroke="#dc3545"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d={icons[type]}
            stroke="#fff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {type === 'info' && (
            <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2" />
          )}
        </svg>
      )}
      <span className="emp-toast-message">{message}</span>
    </div>
  );
}

/** Full screen loading overlay */
export function Loader({ message = 'Please wait...' }) {
  return (
    <div className="loader-ov">
      <div className="loader-box">
        <div className="loader-spin" />
        <div className="loader-msg">{message}</div>
      </div>
    </div>
  );
}
